import React, { createContext, useContext, useEffect, useState } from "react";
import { userService } from "../service/User/user.service";
import { updateAbility } from "../ability/ability";

interface AuthContextType {
  currentUser: any;
  loading: boolean;
  setCurrentUser: (currentUser: any) => void;
  refreshCurrentUser: () => Promise<void>;
}

const AuthContext = createContext<AuthContextType | null>(null);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [currentUser, setCurrentUser] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  const refreshCurrentUser = async () => {
    const loggedIn = localStorage.getItem("loggedIn");
    if (!loggedIn) return;

    try {
      const res = await userService.getCurrentUser();
      if (res?.data?.success) {
        setCurrentUser(res?.data?.data);
        updateAbility(res?.data?.data?.permissions || []);
      }
    } catch (error) {
      console.error("Failed to refresh user:", error);
    }
  };

  useEffect(() => {
    const loggedIn = localStorage.getItem("loggedIn");

    if (!loggedIn) {
      setLoading(false);
      return;
    }

    userService
      .getCurrentUser()
      .then((res) => {
        if (res?.data?.success) {
          setCurrentUser(res?.data?.data);
          updateAbility(res?.data?.data?.permissions || []);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <AuthContext.Provider
      value={{
        currentUser,
        loading,
        setCurrentUser,
        refreshCurrentUser,
      }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuthContext = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuthContext must be used inside AuthProvider");
  return ctx;
};
